/** Каталог якорей модуля «НС» */
export const ADVERSE_ANCHORS = {
  /** Шестерёнка настроек модуля у пункта «Нежелательные события» в боковом меню */
  nav: {
    settings: 'adverse.nav.settings',
  },
  table: {
    create: 'adverse.table.create',
    statistics: 'adverse.table.statistics',
    reports: 'adverse.table.reports',
    settings: 'adverse.table.settings',
    settingsList: 'adverse.table.settings.list',
    export: 'adverse.table.export',
    resetFilters: 'adverse.table.resetFilters',
    hideCompleted: 'adverse.table.hideCompleted',
    /** Префикс якоря значка фильтра в заголовке колонки, дальше — ключ колонки из `headers` */
    filterPrefix: 'adverse.table.filter.',
    filterFirst: 'adverse.table.filter.number',
    filterLast: 'adverse.table.filter.status',
    demoRow: 'adverse.table.demoRow',
  },
  settings: {
    types: 'adverse.settings.types',
    typesShowInForm: 'adverse.settings.typesShowInForm',
    typesView: 'adverse.settings.typesView',
    typesViewLast: 'adverse.settings.typesViewLast',
    typesCreate: 'adverse.settings.typesCreate',
    probability: 'adverse.settings.probability',
  },
  form: {
    type: 'adverse.form.type',
    dateTime: 'adverse.form.dateTime',
    risk: 'adverse.form.risk',
    department: 'adverse.form.department',
    location: 'adverse.form.location',
    participants: 'adverse.form.participants',
    description: 'adverse.form.description',
    corrective: 'adverse.form.corrective',
    save: 'adverse.form.save',
    questionnairesTab: 'adverse.form.questionnairesTab',
    questionnaires: 'adverse.form.questionnaires',
    filesTab: 'adverse.form.filesTab',
    files: 'adverse.form.files',
    historyTab: 'adverse.form.historyTab',
    assignCoordinator: 'adverse.form.assignCoordinator',
  },
} as const

/** Имена контекстов модуля */
export const ADVERSE_CONTEXTS = {
  table: 'adverse.table',
  form: 'adverse.form',
  formTasks: 'adverse.form.tasks',
} as const
